import { __assign, __extends } from "tslib";
import { Config } from '@amplitude/analytics-core';
import { Http } from './transports/http';
var NodeConfig = /** @class */ (function (_super) {
    __extends(NodeConfig, _super);
    function NodeConfig(apiKey, options) {
        return _super.call(this, __assign(__assign({ transportProvider: new Http() }, options), { apiKey: apiKey })) || this;
    }
    return NodeConfig;
}(Config));
export { NodeConfig };
export var useNodeConfig = function (apiKey, overrides) {
    return new NodeConfig(apiKey, overrides);
};
//# sourceMappingURL=config.js.map